import { useDispatch } from 'react-redux';
import { Checked } from '../../../../../assets/icon/svg';
import { setSelectedSubType } from '../../../../../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

interface Props {
    optionId: number;
    currentSubTypeOptions: SubTypeOption[];
}

export default function SubTypeOptionBox({ optionId, currentSubTypeOptions, }: Props) {

    const dispatch = useDispatch()
    const { typeOfGroupSubType, typeOfGroup  } = useProposalTypeData()

    const handleSubTypeChange = (option: SubTypeOption) => {
        dispatch(setSelectedSubType(option));
    };

    return (
        <>
        {typeOfGroup?.id === optionId &&
            currentSubTypeOptions?.length > 0 && (
                <div className="ml-6 mt-2 space-y-2">
                    {currentSubTypeOptions.map((subOption) => {
                        const isSelected = typeOfGroupSubType.some((item) => item.id === subOption.id);
                        return (
                            <label
                                key={subOption.id}
                                className={`gap-2 flex cursor-pointer p-1.5 rounded border transition-all duration-200 items-center
                                    ${isSelected
                                            ? "border-[#186cb2] bg-[#186cb2]/10 shadow-sm"
                                            : "border-gray-200 bg-white hover:border-[#186cb2] hover:bg-gray-50"
                                    }
                                `}
                            >
                                <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => handleSubTypeChange(subOption)}
                                    className="hidden"
                                />
                                <div
                                    className={`w-3.5 h-3.5 flex items-center justify-center rounded-full border transition
                                        ${isSelected
                                                ? "bg-[#186cb2] border-[#186cb2]"
                                                : "border-gray-400 bg-white"
                                        }
                                    `}
                                >
                                    {isSelected && <Checked />}
                                </div>
                                <span className={`flex-1 whitespace-normal break-words text-xs leading-5 ${ isSelected ? 'font-medium text-[#186cb2]' : 'text-gray-700'}`}>
                                    {subOption.name}
                                </span>
                            </label>
                        )
                    })}
                </div>
            )}
        </>
    )
}
